module.exports = __webpack_public_path__ + "345375e55f92bf71f7c5e395901d88b4.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/images_placeholder.svg
// module id = 78
// module chunks = 0